import { RadioProps } from '@mui/material';
import { ComponentsOverrides, Theme } from '@mui/material/styles';

export default function MuiRadio(theme: Theme): {
  MuiRadio: { defaultProps: RadioProps; styleOverrides: ComponentsOverrides<Theme>['MuiRadio'] };
} {
  return {
    MuiRadio: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          color: theme.palette.primary.main,
          padding: '0 20px 0 20px',
        },
      },
    },
  };
}
